<div
  bsDropdown
  class="gcc-select dropdown"
  [isDisabled]="disabled"
  [isOpen]="isOpen"
  (isOpenChange)="handleDropdownToggle($event)"
>
  <button dropdownToggle type="button" class="form-control text-left dropdown-toggle d-flex align-items-center">
    <span *ngIf="empty; else labels" class="placeholder text-gray flex-grow-1">{{ placeholder || '\u00A0' }}</span>
    <ng-template #labels>
      <div class="flex-grow-1 d-flex">
        <span *ngFor="let value of triggerValue" class="mr-1" [innerHTML]="value"></span>
      </div>
    </ng-template>
  </button>
  <div *dropdownMenu class="dropdown-menu">
    <ng-content></ng-content>
  </div>
</div>
